import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const BASE = 'https://evercorenutrition.com/ev_admin/api/customer/wallet';

export const fetchWallet = createAsyncThunk('wallet/fetch', async (customerId, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}/?customer_id=${customerId}`);
    if (!res.ok) throw new Error('Failed');
    return await res.json();
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

export const addWalletFunds = createAsyncThunk('wallet/add', async (data, { rejectWithValue }) => {
  try {
    const res = await fetch(`${BASE}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error('Failed');
    return await res.json();
  } catch (e) {
    return rejectWithValue(e.message);
  }
});

const walletSlice = createSlice({
  name: 'wallet',
  initialState: { data: null, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWallet.pending, (state) => { state.loading = true; })
      .addCase(fetchWallet.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchWallet.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(addWalletFunds.fulfilled, (state, action) => { state.data = { ...state.data, ...action.payload }; });
  },
});

export default walletSlice.reducer;